<template>
  <div id="app">
    <CloudShop v-if="$route.path === '/cloudShop'"></CloudShop>
    <CustomizedReport v-else-if="$route.path === '/customizedReport'"></CustomizedReport>
    <PustomizedReport v-else-if="$route.path === '/privateReport'"></PustomizedReport>
    <Tiktoksupply v-else-if="$route.path === '/tiktoksupply'"></Tiktoksupply>
    <div v-else>
      <Header :name="isHeader" v-if="!isMobile && $route.meta.keepAlive"></Header>
      <MobileHeader v-else-if="$route.meta.keepAlive"></MobileHeader>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" :hasWebp="hasWebp"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
      <!-- <Header :name="isHeader" v-if="!isMobile"></Header>
      <MobileHeader v-else></MobileHeader>
      <keep-alive>
        <router-view/>
      </keep-alive> -->
      <div class="accept_cookies" v-if="!accept && !website">
        <div class="accept_cookies_box">
          <span class="accept_cookies_box_text">
            ANTDIY uses cookies to provide necessary site functionality and improve your experience. By using our website, you agree to our <span @click="goRouter('/detail', 3)">privacy policy</span>.
          </span>
          <A-Button text='Accept' @onclick="setAccept"></A-Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './components/common/header.vue'
import MobileHeader from './components/common/mobileHeader.vue'
import CloudShop from './components/VXPublicAcount/cloudShop'
import CustomizedReport from './components/VXPublicAcount/customizedReport.vue'
import PustomizedReport from './components/VXPublicAcount/privateReport.vue'
import Tiktoksupply from './components/VXPublicAcount/tiktoksupply.vue'
export default {
  name: 'App',
  components: {
    Header,
    MobileHeader,
    CloudShop,
    CustomizedReport,
    PustomizedReport,
    Tiktoksupply
  },
  data(){
    return {
      isHeader: '/home',
      nameList: ['/home', '/getstore', '/services', '/products', '/blog', '/support', '/help', '/online', '/shopify', '/bigcommerce', '/woocommerce', '/antdiy', '/antdiypro','/cn/home','/cn/products','/cn/solution/raas','/cn/solution/baas','/cn/success','/cn/about-us', '/cn/blog'],
      isMobile: false,
      website: true,
      accept: localStorage.getItem('accept'),
      hasWebp: true,
    }
  },
  created () {
    this.initTawk()
    // 判断是否支持webp
    this.checkWebp();

    this.$axios.get(`https://gateway.antdiy.vip/website-saleswing-service/ip`)
      .then((res)=>{
        if (res.data.success) {
          if (res.data.country && res.data.country.iso_code == "CN") {
            this.website = true
          } else {
            this.website = false
          }
        }
      })
    if(this.$route.path.slice(0,3)==='/cn' && this.$route.path.slice(-5) === ".html"){
      this.$router.push({
        path: `detail?paged=` + this.$route.path.slice(3,-5)
      })
    }
    if(this.$route.path!=='/'){
      this.addmeta()
    }
    if(this.$route.path === '/') {
      let params1 = this.$route.fullPath.slice(2).split('&')[0];
      let name = params1.split('=')[0];
      let value = params1.split('=')[1];
      if (name === 'paged') {
        this.$router.push({
          path: `detail?paged=` + value
          // path: `detail` + this.$route.fullPath.slice(1)
        })
      } else if (name === 'p') {
        this.$router.push({
          path: `detail?p=` + value
        })
      } else if (name === 'cat') {
        this.$router.push({
          path: `blog?cat=` + value
        })
      } else if (name === 'tag') {
        this.$router.push({
          path: `blog?tag=` + value
        })
      } else {
        this.$axios.get(`https://gateway.antdiy.vip/website-saleswing-service/ip`)
        .then((res)=>{
          if (res.data.success) {
            if (res.data.country && res.data.country.iso_code == "CN") {
              this.$router.push({
                path:'/cn/home'
              })
              this.addmeta()
            }else{
              this.$router.push({
                path:'/home'
              })
              this.addmeta()
            }
          }
        })
      }
    } else if (!this.$route.path.slice(1).includes("/")){
      // debugger
      if (this.$route.path.slice(-5) === ".html") {
        this.$router.push({
          path: `detail?paged=` + this.$route.path.slice(1,-5)
        })
      } else if (this.$route.path === "/helpcenter") {
        this.$router.push({
          path: `detail?paged=` + this.$route.path
        })
      }
    } else if (this.$route.path.slice(1).includes("/")) {
      let routeArr = this.$route.path.slice(1).split("/")
      if (routeArr.length === 2) {
        if (routeArr[0] === "category" || routeArr[0] === "tag" ) {
          this.$router.push({
            path: `/blog?tag=` + routeArr[1]
          })
        }
      } else if (routeArr.length === 4) {
        if (routeArr[0] === "category" && routeArr[2] === "page") {
          this.$router.push({
            path: `/blog?tag=${routeArr[1]}&page=${routeArr[3]}`
          })
        }
      }
    }
    if (document.body.offsetWidth > 767) {
      this.isMobile = false
    } else {
      this.isMobile = true
    }
    this.isHeader = this.$route.path
  },
  methods:{
    hiddenBox() {
      console.log("chat loaded");
      let aaa = document.getElementsByClassName('widget-visible')
      if (aaa && aaa.length > 0) {
        Array.from(aaa).forEach(item => {
          let bbb = item.getElementsByTagName('iframe')
          if (bbb && bbb.length > 0) {
            Array.from(bbb).forEach(val => {
              let ccc = val.contentDocument.querySelectorAll('body')
              if (ccc && ccc.length > 0) {
                let ddd = ccc[0].querySelectorAll('.tawk-branding')
                if (ddd && ddd.length > 0) {
                  Array.from(ddd).forEach(pop => {
                    if (pop) {
                      console.log('找到目标元素')
                      pop.style.display = 'none'
                    }
                  })
                }
              }
            })
          }
        })
      }
    },
    initTawk() {
      if(!window.Tawk_API) return
      let _this = this
      window.Tawk_API.onLoad = function () {
        window.Tawk_API.minimize(); 
        _this.hiddenBox()
        window.Tawk_API.setAttributes(
          {
            name: '官网用户',
            email: '',
            hash: "hash value",
          },
          function (error) {}
        );
      };
      window.Tawk_API.onChatMaximized = function () {
        setTimeout(() => {
          _this.hiddenBox()
        }, 200);
      };
    },
    setAccept () {
      localStorage.setItem('accept', 1)
      this.accept = 1
    },
    goRouter (router, id) {
      let query
      if (id) {
        query = { p: id }
      }
      this.$router.push({
        path: router,
        query
      }).catch(err => {
        console.log('e', err)
      })
    },
    addmeta(){
       if(this.$route.path.slice(0,3)=='/cn'){
        let metar=document.getElementsByTagName('meta')[0]
        let oMeta = document.createElement('meta');
        oMeta.name='description'
        oMeta.content ='“全球云店”作为去中心化电商平台，基于混合云技术打造全新生态环境和全面基础设施， 助力企业和创业者找全球商机，做全球增长；零库存、零成本、零知识，一根网线，一台电脑，一个人就能全球大卖!';
        document.getElementsByTagName('head')[0].insertBefore(oMeta,metar);
        let oMeta2 = document.createElement('meta');
        oMeta2.name='keywords'
        oMeta2.content ='跨境电商, 一件代发, 全球云店, 天识科技, 独立站, 一个人的电商, 轻创业, 去中心化, 全球电商平台, 混合云技术, 想法即商业, 开店即开张, 全球商机';
        document.getElementsByTagName('head')[0].insertBefore(oMeta2,metar);
        let oMeta3 = document.createElement('meta');
        oMeta3.setAttribute("http-equiv","content-language")
        oMeta3.content ='zh';
        document.getElementsByTagName('head')[0].insertBefore(oMeta3,metar);
      }else{
        let metar=document.getElementsByTagName('meta')[0]
        let oMeta = document.createElement('meta');
        oMeta.name='description'
        oMeta.content ='ANTDIY is the official dropshipping partner of AliExpress, which is directly connected to AliExpress. ANTDIY provide you with a one-stop solution to purchase cross-border products as simply and reliably as they do from local quality suppliers.';
        document.getElementsByTagName('head')[0].insertBefore(oMeta,metar);
        let oMeta2 = document.createElement('meta');
        oMeta2.name='keywords'
        oMeta2.content ='best quality products on aliexpress, aliexpress dropshipping app, aliexpress app shopify, bigcommerce aliexpress importer';
        document.getElementsByTagName('head')[0].insertBefore(oMeta2,metar);
        let oMeta3 = document.createElement('meta');
        oMeta3.setAttribute("http-equiv","content-language")
        oMeta3.content ='en';
        document.getElementsByTagName('head')[0].insertBefore(oMeta3,metar);
      }
    },
    checkWebp(){
      try{
        this.hasWebp = (document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') == 0);
        console.log('hasWebp: ',this.hasWebp)
      }catch(err) {
        this.hasWebp = false;
      }
    }
  },
  mounted() {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/ws.js", { scope: "/" })
        .then((registration) => {
          console.log("Service Worker 注册成功:", registration);

          // 强制更新
          if (registration.waiting) {
            registration.waiting.postMessage({ type: "SKIP_WAITING" });
          } else if (registration.installing) {
            registration.installing.postMessage({ type: "SKIP_WAITING" });
          }

          registration.onupdatefound = () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.onstatechange = () => {
                if (newWorker.state === "installed") {
                  if (navigator.serviceWorker.controller) {
                    console.log("新 Service Worker 已安装，旧版本将被替换。");
                  } else {
                    console.log("Service Worker 已安装，并首次控制页面。");
                  }
                }
              };
            }
          };
        })
        .catch((error) => {
          console.error("Service Worker 注册失败:", error);
        });
    }
  },
  watch: {
    $route (newVal, oldVal) {
      // console.log(newVal)
      if (this.nameList.indexOf(newVal.path) > -1) {
        this.isHeader = newVal.path
      } else {
        this.isHeader = ''
      }
    }
  }
}
</script>

<style>
#app {
  min-width: 1280px;
  overflow: auto;
}

html, body, div, ul, li, h1, h2, h3, h4, h5, h6, p, dl, dt, dd, ol, form, input, textarea, th, td, select {
  margin: 0;
  padding: 0;
}
*{box-sizing: border-box;font-family: Helvetica !important;}
html, body {
  height: 100%;
  width: 100%;
}

body {
  /* font-family: "Microsoft YaHei"; */
  font-size:14px;
  background: #fff;
}
/* h1, h2, h3, h4, h5, h6{font-weight:normal;} */
ul,ol {
  list-style: none;
}

img {
  border: none;
  vertical-align: middle;
}

a {
  text-decoration: none;
  color: #232323;
}

table {
  border-collapse: collapse;
  table-layout: fixed;
}

input, textarea {
  outline: none;
  border: none;
}

textarea {
  resize: none;
  overflow: auto;
}

.title_icon{
  width: 24px;
  height: 4px;
  background: #FC5421;
  border-radius: 2px;
}

.accept_cookies{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #2D3945;
  z-index: 99;
}
.accept_cookies_box{
  height: 112px;
  width: 1200px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.accept_cookies_box_text{
  font-size: 14px;
  color: #FFFFFF;
  line-height: 24px;
  font-weight: 400;
  width: 750px;
}
.accept_cookies_box_text span{
  text-decoration:underline;
  cursor: pointer;
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  html{
    width: max-content;
    height: max-content;
  }
  /* .home_say_box{
    width: 1100px !important;
  }
  .home_say_content_item{
    width: 540px !important;
  }
  .home_say_content_item_1{
    transform: translateX(-560px) !important;
  }
  .home_say_content_item_2{
    transform: translateX(-1120px) !important;
  }
  .home_say_content_item_3{
    transform: translateX(-1680px) !important;
  }
  .home_say_content_item_4{
    transform: translateX(-2240px) !important;
  }
  .home_say_content_item_5{
    transform: translateX(-2800px) !important;
  }
  .home_say_content_item_6{
    transform: translateX(-3360px) !important;
  }
  .home_say_content_item_7{
    transform: translateX(-3920px) !important;
  } */
}
@media (max-width: 767px){
  #app {
    min-width: 320px;
  }
  .accept_cookies{
    padding: .48rem;
  }
  .accept_cookies_box{
    height: auto;
    width: 100%;
    flex-direction: column;
  }
  .accept_cookies_box_text{
    font-size: .28rem;
    line-height: .48rem;
    width: 100%;
  }
  .accept_cookies_box .ad_button{
    width: 100%;
    text-align: center;
    margin-top: .4rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue